import { render, staticRenderFns } from "./crisis-question.vue?vue&type=template&id=173bacda&"
import script from "./crisis-question.vue?vue&type=script&lang=js&"
export * from "./crisis-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports